"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FullServiceHistoryComponent = void 0;
var core_1 = require("@angular/core");
var vehicle_service_history_service_1 = require("@/_services/vehicle-service-history.service");
var router_1 = require("@angular/router");
var storage_service_1 = require("@/_services/storage-service");
var vehicle_motorplan_service_1 = require("@/_services/vehicle-motorplan.service");
var vehicle_ocall_service_1 = require("@/_services/vehicle-ocall.service");
var vehicle_tyre_search_service_1 = require("@/_services/vehicle-tyre-search.service");
var FullServiceHistoryComponent = /** @class */ (function () {
    function FullServiceHistoryComponent(vehicleServiceHistorysService, activatedRoute, storageService, vehicleMotorplanService, vehicleOnCallService, router, vehiclTyreSearchService) {
        this.vehicleServiceHistorysService = vehicleServiceHistorysService;
        this.activatedRoute = activatedRoute;
        this.storageService = storageService;
        this.vehicleMotorplanService = vehicleMotorplanService;
        this.vehicleOnCallService = vehicleOnCallService;
        this.router = router;
        this.vehiclTyreSearchService = vehiclTyreSearchService;
        this.vehicleServiceHists = [];
        this.isNavShown = false;
        this.loadVehicleServiceHistory(this.storageService.getVin());
        this.loadVehicleMotorplan(this.storageService.getVin(), this.storageService.getSelectedVehicle());
        this.loadVehicleOncall(this.storageService.getVin());
        this.loadVehicleTyreSearch(this.storageService.getVin());
    }
    FullServiceHistoryComponent.prototype.loadVehicleServiceHistory = function (vinNumber) {
        var _this = this;
        var vehicleServiceHistoryObservable = this.vehicleServiceHistorysService.getVehicleServiceHistory(vinNumber);
        vehicleServiceHistoryObservable.subscribe(function (vehicleServiceHistory) {
            _this.vehicleServiceHistory = vehicleServiceHistory;
            _this.vehicleServiceHistory.forEach(function (o, i) {
                _this.loading = true;
                var year = o.clmDateRepaired;
                var getYear = year.slice(0, 4);
                var month = o.clmDateRepaired;
                var getMonth = month.slice(4, 6);
                var day = o.clmDateRepaired;
                var getDay = day.slice(6, 8);
                _this.vehicleServiceHists.push({ clmDateRepaired: getYear + "-" + getMonth + "-" + getDay, serviceHistory: o });
            });
        });
    };
    FullServiceHistoryComponent.prototype.loadVehicleMotorplan = function (vinNumber, vehicleInfo) {
        return __awaiter(this, void 0, void 0, function () {
            var vehicleMotorplanObservable;
            var _this = this;
            return __generator(this, function (_a) {
                this.vinNumber = vinNumber;
                vehicleMotorplanObservable = this.vehicleMotorplanService.getVehicleMotorplan(vinNumber);
                vehicleMotorplanObservable.subscribe(function (vehicleMotorplan) {
                    _this.vehicleMotorplan = vehicleMotorplan;
                    if (_this.vehicleMotorplan.expiryDate !== null) {
                        var year = _this.vehicleMotorplan.expiryDate;
                        var getYear = year.slice(0, 4);
                        var month = _this.vehicleMotorplan.expiryDate;
                        var getMonth = month.slice(4, 6);
                        var day = _this.vehicleMotorplan.expiryDate;
                        var getDay = day.slice(6, 8);
                        _this.loading = true;
                        _this.parentVehicleMotorplan = { motoplan: { expiryDate: getYear + "-" + getMonth + "-" + getDay, expiryKm: Number(_this.vehicleMotorplan.expiryKm) }, vehicleInfo: vehicleInfo };
                    }
                });
                return [2 /*return*/];
            });
        });
    };
    FullServiceHistoryComponent.prototype.loadVehicleOncall = function (vinNumber) {
        var _this = this;
        this.loading = true;
        var vehicleOnCallServiceObservable = this.vehicleOnCallService.getVehicleOncall(vinNumber);
        vehicleOnCallServiceObservable.subscribe(function (vehicleOnCall) {
            _this.vehicleOnCall = vehicleOnCall;
            if (_this.vehicleOnCall !== null) {
                _this.parentOnCall = { onCall: _this.vehicleOnCall };
            }
        });
    };
    FullServiceHistoryComponent.prototype.loadVehicleTyreSearch = function (vinNumber) {
        var _this = this;
        var vehicleServiceTyreSearchObservable = this.vehiclTyreSearchService.getVehicleTyreSearch(vinNumber);
        vehicleServiceTyreSearchObservable.subscribe(function (vehicleTyreSearch) {
            _this.vehicleTyreSearch = vehicleTyreSearch;
            _this.vehicleTyreSearch.z55TyreInfo.forEach(function (o, i) {
                if (i === 0) {
                    _this.loading = true;
                    _this.vehicleTyreSearchParent = { tyerInfomation: o, retailPrice: Number(o.retailPrice) * 4, vehicleTyreSearch: _this.vehicleTyreSearch };
                }
            });
        });
    };
    FullServiceHistoryComponent.prototype.toggleNavShow = function () {
        this.isNavShown = !this.isNavShown;
    };
    FullServiceHistoryComponent.prototype.ngOnInit = function () {
    };
    FullServiceHistoryComponent = __decorate([
        core_1.Component({ template: require('./fullservicehistory.component.html') }),
        __metadata("design:paramtypes", [vehicle_service_history_service_1.VehicleServiceHistorysService,
            router_1.ActivatedRoute,
            storage_service_1.StorageService,
            vehicle_motorplan_service_1.VehicleMotorplanService,
            vehicle_ocall_service_1.VehicleOnCallService,
            router_1.Router,
            vehicle_tyre_search_service_1.VehiclTyreSearchService])
    ], FullServiceHistoryComponent);
    return FullServiceHistoryComponent;
}());
exports.FullServiceHistoryComponent = FullServiceHistoryComponent;
